import { CommonAction, ICommonActionMetadata } from '../types/action-types';

/**
 * Registry for common actions displayed in the common actions dropdown
 */
export const COMMON_ACTIONS: ICommonActionMetadata[] = [
    {
        id: CommonAction.FETCH_CUSTOMER,
        label: 'Fetch Customer',
        requiresInput: true,
        inputLabel: 'Customer',
    },
    {
        id: CommonAction.FETCH_DISCOUNT_CODE,
        label: 'Fetch Discount Code',
        requiresInput: true,
        inputLabel: 'Discount Code',
    },
    {
        id: CommonAction.FETCH_ORDER,
        label: 'Fetch Order',
        requiresInput: true,
        inputLabel: 'Order Name',
    },
    {
        id: CommonAction.FETCH_ORDER_BY_ID,
        label: 'Fetch Order By Id',
        requiresInput: true,
        inputLabel: 'Order ID',
    },
    {
        id: CommonAction.FETCH_ORDER_BY_RMA_ID,
        label: 'Fetch Order By RMA id',
        requiresInput: true,
        inputLabel: 'RMA ID',
    },
    {
        id: CommonAction.FETCH_DRAFT_ORDER,
        label: 'Fetch Draft Order',
        requiresInput: true,
        inputLabel: 'Order Name',
    },
    {
        id: CommonAction.FETCH_DRAFT_ORDER_BY_ID,
        label: 'Fetch Draft Order By Id',
        requiresInput: true,
        inputLabel: 'Order ID',
    },
    {
        id: CommonAction.FETCH_PRODUCT,
        label: 'Fetch Product',
        requiresInput: true,
        inputLabel: 'Product',
    },
    {
        id: CommonAction.FETCH_VARIANTS,
        label: 'Fetch Variants',
        requiresInput: true,
        inputLabel: 'Variant IDs',
    },
    {
        id: CommonAction.FETCH_FULFILLMENT_BY_ID,
        label: 'Fetch Fulfillment By Id',
        requiresInput: true,
        inputLabel: 'Fulfillment ID',
    },
    {
        id: CommonAction.FETCH_RMA,
        label: 'Fetch RMA',
        requiresInput: true,
        inputLabel: 'RMA ID',
    },
    {
        id: CommonAction.FETCH_ORDER_ELIGIBILITY_LEGACY,
        label: 'Fetch Order Eligibility (Legacy)',
        requiresInput: true,
        inputLabel: 'Order Name',
    },
    // Sys Admin Only Actions
    {
        id: CommonAction.FETCH_SUPERADMIN_ACTIONS,
        label: 'Fetch Super Admin Actions',
        requiresInput: false,
        isSysAdminOnly: true,
    },
    // sort below actions by label name alphabetically
    {
        id: CommonAction.BULK_RMA_AUTO_REFUND,
        label: 'Auto Refund RMAs',
        requiresInput: true,
        inputLabel: 'RMA IDs',
        requiresToggle: true,
        toggleLabel: 'Skip Policy Rule Check',
        isSysAdminOnly: true,
    },
    {
        id: CommonAction.CHANGE_RMA_STATUS_DIRECTLY,
        label: 'Change RMA status directly',
        requiresInput: true,
        inputLabel: 'RMA IDs',
        requiresDirectRmaStatusTarget: true,
        isSysAdminOnly: true,
    },
    {
        id: CommonAction.CREATE_SECONDARY_PORTAL,
        label: 'Create Secondary Portal',
        requiresInput: true,
        inputLabel: 'Portal Name',
        isSysAdminOnly: true,
    },
    {
        id: CommonAction.COPY_STORE_SETTINGS,
        label: 'Copy Store Settings',
        requiresStoresSelect: true,
        isSysAdminOnly: true,
    },
    {
        id: CommonAction.DUPLICATE_STORE,
        label: 'Duplicate Store (V2)',
        requiresStoresSelect: true,
        isSysAdminOnly: true,
    },
    {
        id: CommonAction.CLEAR_TRANSLATIONS_CACHE,
        label: 'Clear Translations Cache',
        requiresInput: false,
        isSysAdminOnly: true,
    },
    {
        id: CommonAction.CHANGE_STORE_OWNER,
        label: 'Change Store Owner',
        requiresInput: true,
        inputLabel: 'New Owner Email',
        isSysAdminOnly: true,
    },
    {
        id: CommonAction.BULK_RMA_CANCELLED,
        label: 'Mark RMAs as Cancelled',
        requiresInput: true,
        inputLabel: 'RMA IDs',
        isSysAdminOnly: true,
    },
    {
        id: CommonAction.BULK_RMA_DONE,
        label: 'Mark RMAs as Done',
        requiresInput: true,
        inputLabel: 'RMA IDs',
        requiresAdditionalInput: true,
        additionalInputLabel: 'Type \'skip\' to pass over Policy Rule settings',
        isSysAdminOnly: true,
    },
    {
        id: CommonAction.BULK_RMA_APPROVED,
        label: 'Mark RMAs as Approved',
        requiresInput: true,
        inputLabel: 'RMA IDs',
        isSysAdminOnly: true,
    },
    {
        id: CommonAction.REMOVE_USER_FROM_STORE,
        label: 'Remove User From Store',
        requiresInput: true,
        inputLabel: 'User Email',
        isSysAdminOnly: true,
    },
    {
        id: CommonAction.TRANSFER_REJECTED_RMA_TO_CANCELED,
        label: 'Transfer Rejected RMA to Canceled',
        requiresInput: true,
        inputLabel: 'RMA IDs',
        isSysAdminOnly: true,
    },
    {
        id: CommonAction.TROUBLESHOOTING_UPLOAD_CSV,
        label: 'Upload CSV',
        requiresFileUpload: true,
        isSysAdminOnly: true,
    },
];

/**
 * Get common action metadata by ID
 */
export const getCommonAction = (id: CommonAction): ICommonActionMetadata | undefined => {
    return COMMON_ACTIONS.find(action => action.id === id);
};

/**
 * Get all common actions (optionally filtered by sys admin status)
 */
export const getAllCommonActions = (includeSysAdminOnly: boolean = false): ICommonActionMetadata[] => {
    if (includeSysAdminOnly) {
        return COMMON_ACTIONS;
    }
    return COMMON_ACTIONS.filter(action => !action.isSysAdminOnly);
};

